export class AuthorizationModel {
  permission: string;
  permissions: string[];
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/permission/models/authorize.model.ts